if (!customElements.get('mt-collection-list')) {
  customElements.define(
    'mt-collection-list',
    class MtCollectionList extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.tabs = Array.from(this.querySelectorAll('.mt-collection-list__tab'));
        this.cards = Array.from(this.querySelectorAll('.mt-collection-list__card'));

        this.onClick = (event) => {
          const tab = event.target.closest('.mt-collection-list__tab');
          if (!tab || !this.contains(tab)) return;
          this.activate(tab.dataset.filter);
        };

        this.onKeydown = (event) => {
          const currentTab = event.target.closest('.mt-collection-list__tab');
          if (!currentTab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

          event.preventDefault();
          const currentIndex = this.tabs.indexOf(currentTab);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;

          this.tabs[nextIndex]?.focus();
          this.activate(this.tabs[nextIndex]?.dataset.filter);
        };

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.initialized = true;
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.initialized = false;
      }

      activate(filter = 'all') {
        const selectedFilter = filter || 'all';

        this.tabs.forEach((tab) => {
          const isSelected = tab.dataset.filter === selectedFilter;
          tab.setAttribute('aria-selected', String(isSelected));
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        this.cards.forEach((card) => {
          card.hidden = selectedFilter !== 'all' && card.dataset.group !== selectedFilter;
        });

        this.dispatchEvent(
          new CustomEvent('mt:collection-list:filter', {
            bubbles: true,
            detail: { filter: selectedFilter }
          })
        );
      }
    }
  );
}
